<template>
  <div class="admin">
    <button class="admin__logout" @click="logout">Log uit</button>
    <div class="admin__wrapper">
      <img src="../assets/img/icon.png" alt="icon Iivaara Wilderness Lodge">
      <h1>Admin-dashboard</h1>
      <h2>Subscribers</h2>
      <label for="zoeken">Zoeken</label><input type="text" class="input" id="zoeken" v-model="search">
      <div class="admin__subscribers">
        <table>
          <thead>
          <tr>
            <th>Voornaam</th>
            <th>Naam</th>
            <th>E-mail</th>
            <th>Acties</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in filteredSubscribers" :key="item.id">
            <td>{{ item.firstname }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.email }}</td>
            <td><span class="error control" @click="unsubscribe(item.id)">Verwijder</span></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal" v-if="deleteSubscriber !== null">
      <div class="modal__wrapper">
        <button class="close modal__close" @click="deleteSubscriber = null">
          <fa-icon icon="times"></fa-icon>
        </button>
        <div class="modal__title">Subscriber verwijderen?</div>
        <div class="modal__body">
          <p>Zeker dat je de subscriber wenst te verwijderen?</p>
          <p>Wanneer je deze verwijdert krijgt de bezoeker niet langer updates in de vorm van nieuwsbrieven en wordt
            alle persoonlijke data op de database gewist.</p>
        </div>
        <div class="modal__controls">
          <button class="button button--accept" @click="unsubscribeConfirm">Ja</button>
          <button class="button button--cancel" @click="unsubscribeDecline">Nee</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin";

export default {
  name: "Admin",

  data() {
    return {
      search: "",
      subscribers: [],
      deleteSubscriber: null
    }
  },

  created() {
    this.fetchSubscribers();
  },

  computed: {
    filteredSubscribers() {
      return this.search ? this.subscribers.filter(sub => sub.name.toLowerCase().match(this.search.toLowerCase()) || sub.firstname.toLowerCase().match(this.search.toLowerCase()) || sub.email.toLowerCase().match(this.search.toLowerCase()) || `${sub.firstname.toLowerCase()} ${sub.name.toLowerCase()}`.match(this.search.toLowerCase())) : this.subscribers;
    }
  },

  methods: {
    logout() {
      localStorage.removeItem('LoggedUser');
      this.$router.push('/');
    },

    unsubscribe(id) {
      this.deleteSubscriber = id;
    },

    unsubscribeConfirm() {
      AdminService.deleteSubscriber({id: this.deleteSubscriber}).then(res => {
        if (res) {
          this.deleteSubscriber = null;
          this.fetchSubscribers();
        }
      })
    },

    unsubscribeDecline() {
      this.deleteSubscriber = null;
    },

    fetchSubscribers() {
      AdminService.getSubscribers().then(res => {
        if (res && res.status && res.data) {
          this.subscribers = res.data;
        }
      });
    }
  }
}
</script>